import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_load_container_orders_grid_ComponentContextService } from './FootprintManager.load_container_orders_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';


interface IFootprintManager_load_container_orders_gridComponentEntity {
  OrderId?: number, ShipmentId?: number, Order?: { Id?: number, CreatedSysDateTime?: string, FulfillmentDate?: string, LookupCode?: string, Notes?: string, OrderClassId?: number, OrderStatusId?: number, OwnerReference?: string, PreferredCarrierId?: number, PreferredWarehouseId?: number, ProjectId?: number, RequestedDeliveryDate?: string, VendorReference?: string, Status?: { Id?: number, Name?: string }, OrderClass?: { LookupCode?: string, OrderClassTypeId?: number, OrderTypeId?: number }, Project?: { LookupCode?: string, Name?: string, OwnerId?: number, Owner?: { LookupCode?: string, Name?: string } }, Account?: { Id?: number, AccountsContactsLookup?: { ContactId?: number, Contact?: { FirstName?: string, LastName?: string, PrimaryEmail?: string, PrimaryTelephone?: string, Address?: { AttentionOf?: string, City?: string, Country?: string, Line1?: string, Line2?: string, PostalCode?: string, State?: string } } }[] }, PreferredWarehouse?: { Id?: number, Name?: string }, PreferredCarrier?: { Id?: number, Name?: string }, PreferredCarrierServiceType?: { Id?: number, Name?: string }, Addresses?: { AttentionOf?: string, Country?: string, FirstName?: string, LastName?: string, Line1?: string, Line2?: string, PostalCode?: string, PrimaryEmail?: string, PrimaryTelephone?: string, State?: string }[] }, Shipment?: { ContainerSize?: string, ExpectedDate?: string, LoadContainerSequence?: number, LookupCode?: string, SealId?: string, StatusId?: number, TrackingIdentifier?: string, WaveId?: number, Wave?: { StatusId?: number, Status?: { Name?: string } } }}

interface IFootprintManager_load_container_orders_gridComponentInParams {
  loadContainerId: number, edit?: boolean, warehouseId?: number, orderTypeId?: number, status_id?: number}

interface IFootprintManager_load_container_orders_gridComponentOutParams {
  warehouseId?: number, orderTypeId?: number, ownerId?: number, projectId?: number, carrierId?: number, createdCount?: number}

class FootprintManager_load_container_orders_gridComponentRowModel extends GridRowModel {
  grid: FootprintManager_load_container_orders_gridComponent;
  entity: IFootprintManager_load_container_orders_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
    LoadSequence_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    SealId_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
  });

  override cells = {
    Order: null,
    Shipment: null,
    Available: null,
    Picked: null,
    Loaded: null,
    Received: null,
    Putaway: null,
    OrderClass_LookupCode: null,
    LoadSequence: null,
    Status_Name: null,
    Project_Owner_Name: null,
    Project_Name: null,
    OwnerReference: null,
    VendorReference: null,
    SealId: null,
    CreatedSysDateTime: null,
    FulfillmentDate: null,
    RequestedDeliveryDate: null,
    Notes: null,
    PreferredWarehouse_Name: null,
    PreferredCarrier_Name: null,
    PreferredCarrierServiceType_Name: null,
  }



  constructor(
    grid: FootprintManager_load_container_orders_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: FootprintManager_ShellService,
private $datasources: FootprintManager_DatasourceService,
private $flows: FootprintManager_FlowService,
private $reports: FootprintManager_ReportService,
private $localization: FootprintManager_LocalizationService,
private $operations: FootprintManager_OperationService,
private $logger: CleanupLoggerService,
private $context: FootprintManager_load_container_orders_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.Order = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.Order,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Shipment = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Shipment,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Available = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Available,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Picked = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Picked,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Loaded = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Loaded,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Received = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Received,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Putaway = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Putaway,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.OrderClass_LookupCode = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.OrderClass_LookupCode,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.LoadSequence = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.LoadSequence,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['LoadSequence_edit'] as DatexFormControl, null, false, false, '', '', null)
      );
    
    this.cells.Status_Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Status_Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Project_Owner_Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Project_Owner_Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Project_Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Project_Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.OwnerReference = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.OwnerReference,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.VendorReference = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.VendorReference,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.SealId = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.SealId,
      new TextModel(null, null, null, null, null)
,
      new TextBoxModel(this.formGroup.controls['SealId_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    this.cells.CreatedSysDateTime = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.CreatedSysDateTime,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.FulfillmentDate = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.FulfillmentDate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.RequestedDeliveryDate = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.RequestedDeliveryDate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Notes = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Notes,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.PreferredWarehouse_Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.PreferredWarehouse_Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.PreferredCarrier_Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.PreferredCarrier_Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.PreferredCarrierServiceType_Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.PreferredCarrierServiceType_Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    
  }

  async $initializeExisting(entity: IFootprintManager_load_container_orders_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.OrderId,this.entity.ShipmentId].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IFootprintManager_load_container_orders_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.OrderId,this.entity.ShipmentId].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = {};
    set($resultKey, 'OrderId',this.entity.OrderId);
    set($resultKey, 'ShipmentId',this.entity.ShipmentId);
    const inParams = {
      $keys:[$resultKey],
      loadContainerId:  $grid.inParams.loadContainerId ,
      fullTextSearch:  $grid.fullTextSearch ,
    };
    const data = await this.$datasources.LoadContainers.ds_order_shipment_by_load_container_grid.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IFootprintManager_load_container_orders_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.Order.displayControl as TextModel).text = $row.entity.Order?.LookupCode;
    (this.cells.Shipment.displayControl as TextModel).text = $row.entity.Shipment?.LookupCode;
    (this.cells.OrderClass_LookupCode.displayControl as TextModel).text = $row.entity.Order?.OrderClass?.LookupCode;
    (this.cells.LoadSequence.displayControl as TextModel).text = $row.entity.Shipment?.LoadContainerSequence?.toString();
    (this.cells.LoadSequence.editControl as NumberBoxModel).reset($row.entity.Shipment?.LoadContainerSequence);
    (this.cells.Status_Name.displayControl as TextModel).text = $row.entity.Order?.Status?.Name;
    (this.cells.Project_Owner_Name.displayControl as TextModel).text = $row.entity.Order?.Project?.Owner?.Name;
    (this.cells.Project_Name.displayControl as TextModel).text = $row.entity.Order?.Project?.Name;
    (this.cells.OwnerReference.displayControl as TextModel).text = $row.entity.Order?.OwnerReference;
    (this.cells.VendorReference.displayControl as TextModel).text = $row.entity.Order?.VendorReference;
    (this.cells.SealId.displayControl as TextModel).text = $row.entity.Shipment?.SealId;
    (this.cells.SealId.editControl as TextBoxModel).reset($row.entity.Shipment?.SealId);
    (this.cells.Notes.displayControl as TextModel).text = $row.entity.Order?.Notes;
    (this.cells.PreferredWarehouse_Name.displayControl as TextModel).text = $row.entity.Order?.PreferredWarehouse?.Name;
    (this.cells.PreferredCarrier_Name.displayControl as TextModel).text = $row.entity.Order?.PreferredCarrier?.Name;
    (this.cells.PreferredCarrierServiceType_Name.displayControl as TextModel).text = $row.entity.Order?.PreferredCarrierServiceType?.Name;

    await this.on_row_data_loaded();
  }

  override async refresh() {
    if (this.grid.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
    } else {
      await this.on_line_edit();
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
      case 'Order' : {
        this.on_lookup_clicked();
        break;
      }
    }
  }

  //#region private flows
  on_row_data_loaded(event = null) {
    return this.on_row_data_loadedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_data_loadedInternal(
    $row: FootprintManager_load_container_orders_gridComponentRowModel,
  $grid: FootprintManager_load_container_orders_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_load_container_orders_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  // O.Arias - 09/13/2024
  
  // Set Date/Time Formats
  const format = `${$settings.FootprintManager.DateFormat}, ${$settings.FootprintManager.TimeFormat.toUpperCase() == '24 HOUR' ? 'HH:mm' : 'LT'}`;
  
  if ($utils.isDefined(format)) {
  
      if ($utils.isDefined($row.entity.Order?.CreatedSysDateTime)) {
          $row.cells.CreatedSysDateTime.displayControl.text = $utils.date.format($row.entity.Order?.CreatedSysDateTime, format);
      }
  
      if ($utils.isDefined($row.entity.Order?.FulfillmentDate)) {
          $row.cells.FulfillmentDate.displayControl.text = $utils.date.format($row.entity.Order?.FulfillmentDate, format);
      }
  
      if ($utils.isDefined($row.entity.Order?.RequestedDeliveryDate)) {
          $row.cells.RequestedDeliveryDate.displayControl.text = $utils.date.format($row.entity.Order?.RequestedDeliveryDate, format);
      }
  
  }
  }
  on_lookup_clicked(event = null) {
    return this.on_lookup_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_lookup_clickedInternal(
    $row: FootprintManager_load_container_orders_gridComponentRowModel,
  $grid: FootprintManager_load_container_orders_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_load_container_orders_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  //O.Arias - 09/13/2024
  
  /* On line id clicked */
  if ($row.entity.Order?.OrderClass.OrderTypeId === 1 && $row.entity.Order?.OrderClass.OrderClassTypeId === 12) {
  
      //ASN
      $shell.FootprintManager.openasn_order_editor({ order_id: $row.entity.OrderId });
  }
  else {
  
      if ($row.entity.Order?.OrderClass.OrderTypeId === 1) {
  
          //PO
          $shell.FootprintManager.openpurchase_order_editor({ orderId: $row.entity.OrderId });
      } else {
  
          if ($row.entity.Order?.OrderClass.OrderTypeId === 2) {
  
              //SO
              $shell.FootprintManager.opensales_order_editor({ orderId: $row.entity.OrderId });
          }
      }
  }
  }
  on_line_edit(event = null) {
    return this.on_line_editInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_line_editInternal(
    $row: FootprintManager_load_container_orders_gridComponentRowModel,
  $grid: FootprintManager_load_container_orders_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_load_container_orders_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  //O.Arias - 09/13/2024
  
  let shipmentId = $row.entity.ShipmentId;
  let shipment_update: boolean = false;
  
  const shipment_payload: any = {}
  
  if ($utils.isDefined(shipmentId)) {
  
      if ($row.cells.SealId.editControl.isChanged) {
          shipment_payload.SealId = $row.cells.SealId.editControl.value;
          shipment_update = true;
      }
  
      if ($row.cells.LoadSequence.editControl.isChanged) {
          shipment_payload.LoadContainerSequence = $row.cells.LoadSequence.editControl.value;
          shipment_update = true;
      }
  }
  
  if (shipment_update) {
      try {
  
          if ($utils.isDefined(shipment_payload)) {
              await $flows.Utilities.crud_update_flow({
                  entitySet: 'Shipments',
                  id: shipmentId,
                  entity: shipment_payload
              });
          }
  
          await $row.refresh();
      } catch (error) {
          $shell.FootprintManager.showErrorDetails('Save', 'Error on save.', error);
          throw error; // to prevent displayMode 
      }
  }
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
  ],
  selector: 'FootprintManager-load_container_orders_grid',
  templateUrl: './FootprintManager.load_container_orders_grid.component.html'
})
export class FootprintManager_load_container_orders_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IFootprintManager_load_container_orders_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;

canEdit: boolean = true;
// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['fit-content-table']);

  fullTextSearch: string;

  inParams: IFootprintManager_load_container_orders_gridComponentInParams = { loadContainerId: null, edit: null, warehouseId: null, orderTypeId: null, status_id: null };

  outParams: IFootprintManager_load_container_orders_gridComponentOutParams = { warehouseId: null, orderTypeId: null, ownerId: null, projectId: null, carrierId: null, createdCount: null };

  //#region Variables
  vars: { ownerId?: number, projectId?: number } = { };
  //#endregion
  //#region Events
  @Output()
  outParamsChange = new EventEmitter<{ warehouseId?: number, orderTypeId?: number, ownerId?: number, projectId?: number, carrierId?: number, createdCount?: number }>();
  
  events = {
    outParamsChange: { emit: () => { this.outParamsChange.emit(this.outParams); } }
  }
  //#endregion

  headers = {
     Order: new GridHeaderModel(new HeaderStyles(null, null), 'Order', 'Order', false, false, null, false),       Shipment: new GridHeaderModel(new HeaderStyles(null, null), 'Shipment', 'Shipment', false, false, null, false),       Available: new GridHeaderModel(new HeaderStyles(null, null), 'Available', 'Available %', false, false, null, false),       Picked: new GridHeaderModel(new HeaderStyles(null, null), 'Picked', 'Picked %', false, false, null, false),       Loaded: new GridHeaderModel(new HeaderStyles(null, null), 'Loaded', 'Loaded %', false, false, null, false),       Received: new GridHeaderModel(new HeaderStyles(null, null), 'Received', 'Received %', false, false, null, false),       Putaway: new GridHeaderModel(new HeaderStyles(null, null), 'Putaway', 'Putaway %', false, false, null, false),       OrderClass_LookupCode: new GridHeaderModel(new HeaderStyles(null, null), 'OrderClass_LookupCode', 'Order class', false, false, null, false),       LoadSequence: new GridHeaderModel(new HeaderStyles(null, null), 'LoadSequence', 'Load sequence', false, false, null, false),       Status_Name: new GridHeaderModel(new HeaderStyles(null, null), 'Status_Name', 'Status', false, false, null, false),       Project_Owner_Name: new GridHeaderModel(new HeaderStyles(null, null), 'Project_Owner_Name', 'Owner', false, false, null, false),       Project_Name: new GridHeaderModel(new HeaderStyles(null, null), 'Project_Name', 'Project', false, false, null, false),       OwnerReference: new GridHeaderModel(new HeaderStyles(null, null), 'OwnerReference', 'Owner reference', false, false, null, false),       VendorReference: new GridHeaderModel(new HeaderStyles(null, null), 'VendorReference', 'Vendor reference', false, false, null, false),       SealId: new GridHeaderModel(new HeaderStyles(null, null), 'SealId', 'Seal ID', false, false, null, false),       CreatedSysDateTime: new GridHeaderModel(new HeaderStyles(null, null), 'CreatedSysDateTime', 'Created date', false, false, null, false),       FulfillmentDate: new GridHeaderModel(new HeaderStyles(null, null), 'FulfillmentDate', 'Fulfillment date', false, false, null, false),       RequestedDeliveryDate: new GridHeaderModel(new HeaderStyles(null, null), 'RequestedDeliveryDate', 'Requested delivery date', false, false, null, false),       Notes: new GridHeaderModel(new HeaderStyles(null, null), 'Notes', 'Notes', false, false, null, false),       PreferredWarehouse_Name: new GridHeaderModel(new HeaderStyles(null, null), 'PreferredWarehouse_Name', 'Warehouse', false, false, null, false),       PreferredCarrier_Name: new GridHeaderModel(new HeaderStyles(null, null), 'PreferredCarrier_Name', 'Carrier', false, false, null, false),       PreferredCarrierServiceType_Name: new GridHeaderModel(new HeaderStyles(null, null), 'PreferredCarrierServiceType_Name', 'Service type', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: FootprintManager_load_container_orders_gridComponentRowModel[] = [];

  @Input('loadContainerId') set $inParams_loadContainerId(value: any) {
    this.inParams['loadContainerId'] = value;
  }
  get $inParams_loadContainerId(): any {
    return this.inParams['loadContainerId'] ;
  }
  @Input('edit') set $inParams_edit(value: any) {
    this.inParams['edit'] = value;
  }
  get $inParams_edit(): any {
    return this.inParams['edit'] ;
  }
  @Input('warehouseId') set $inParams_warehouseId(value: any) {
    this.inParams['warehouseId'] = value;
  }
  get $inParams_warehouseId(): any {
    return this.inParams['warehouseId'] ;
  }
  @Input('orderTypeId') set $inParams_orderTypeId(value: any) {
    this.inParams['orderTypeId'] = value;
  }
  get $inParams_orderTypeId(): any {
    return this.inParams['orderTypeId'] ;
  }
  @Input('status_id') set $inParams_status_id(value: any) {
    this.inParams['status_id'] = value;
  }
  get $inParams_status_id(): any {
    return this.inParams['status_id'] ;
  }

  topToolbar = {
      add: new ToolModel(new ButtonModel('add', new ButtonStyles(['creation'], null), false, false, false, 'Add orders', 'icon-ic_fluent_add_20_regular', null)
    , false),
      remove: new ToolModel(new ButtonModel('remove', new ButtonStyles(null, null), false, false, false, 'Remove selected', 'icon-ic_fluent_dismiss_circle_20_regular', null)
    , false)
  };

  bottomToolbar = {
  };




  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: FootprintManager_ShellService,
    private $datasources: FootprintManager_DatasourceService,
    private $flows: FootprintManager_FlowService,
    private $reports: FootprintManager_ReportService,
    private $localization: FootprintManager_LocalizationService,
    private $operations: FootprintManager_OperationService,
    private $logger: CleanupLoggerService,
    private $context: FootprintManager_load_container_orders_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Orders by load container';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$checkRequiredInParams();
    if (!this.$hasMissingRequiredInParams) {
      this.$init();
    } else {
      this.$initEmpty();
    }
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$checkRequiredInParams();
      if(!this.$hasMissingRequiredInParams) {
        this.$init();
      } else {
        this.$initEmpty();
      }
    }
  }

  $missingRequiredInParams = [];
  get $hasMissingRequiredInParams(): boolean {
    return !!this.$missingRequiredInParams.length;
  }
  
  $checkRequiredInParams() {
    this.$missingRequiredInParams = [];
      if(isNil(this.inParams.loadContainerId)) {
        this.$missingRequiredInParams.push('loadContainerId');
      }
  }

  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 25;


    await this.on_init();
    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    if (this.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      loadContainerId:  $grid.inParams.loadContainerId ,
      fullTextSearch:  $grid.fullTextSearch ,
    };
    try {
      const data = await this.$datasources.LoadContainers.ds_order_shipment_by_load_container_grid.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IFootprintManager_load_container_orders_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new FootprintManager_load_container_orders_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

    await this.on_data_loaded();
  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }

  selectedRows: FootprintManager_load_container_orders_gridComponentRowModel[] = [];
  hasSelectedRows() {
    return this.selectedRows.length > 0;
  }

  async $selectionChanged(selectedRows: any[]) {
    this.selectedRows = selectedRows;
  }

  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_remove_selected(event = null) {
    return this.on_remove_selectedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_remove_selectedInternal(
    $grid: FootprintManager_load_container_orders_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_load_container_orders_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  //O.Arias - 09/13/2024
  
  const selectedRows = $grid.selectedRows;
  
  if (selectedRows.length === 0) {
      $shell.FootprintManager.openErrorDialog('Error removing orders', 'No orders selected.');
      return;
  } else {
  
      const candidates = [];
      const failures = [];
      const errors = [];
  
      for (const row of selectedRows) {
  
          //No validation needed, we'll populate the candidates right away
  
          candidates.push(row);
      }
  
      //No candidate
      if (candidates.length === 0) {
          const title = 'Error removing orders';
          const errorMessage = `Order(s) ${failures.map(c => c.entity.Order?.LookupCode)?.filter((value, index, array) => array.indexOf(value) === index)?.join(',')} cannot be removed`;
          const errorList = errors;
          await $shell.FootprintManager.openErrorDialog(title, errorMessage, errorList);
          return;
      } else {
  
          const confirmCandidates = `Order(s) ${candidates.map(c => c.entity.Order?.LookupCode)?.filter((value, index, array) => array.indexOf(value) === index)?.join(',')} - will be removed from the load container.`
  
          let confirm = false;
  
  
          if (failures.length >= 1) {
  
              const title = 'Some order(s) cannot be removed';
              const message = `Do you still want to continue?\r\n\r\n ${confirmCandidates}\r\n\r\n ${errors.join('\r\n\r\n')}`;
              confirm = await $shell.FootprintManager.openConfirmationDialog(title, message);
  
          } else {
  
              const title = 'Remove the following order(s)';
              const message = confirmCandidates;
              confirm = await $shell.FootprintManager.openConfirmationDialog(title, message, 'Proceed');
          }
  
          if (confirm) {
  
              const candidateSuccess = [];
              const candidateFailures = [];
              const errorMsgList = [];
              const errorMsgListDetails = [];
  
              for (const candidate of candidates) {
                  try {
  
                      const flowParams = {
                          orderId: candidate.entity.OrderId,
                          shipmentId: candidate.entity.ShipmentId,
                          loadContainerId: $grid.inParams.loadContainerId
                      }
  
                      let reasons: string[];
  
                      var result = await $flows.LoadContainers.remove_order_flow(flowParams);
                      if ($utils.isDefined(result.result)) {
                          reasons = [result.result];
                      }
  
                      if ($utils.isDefined(reasons)) {
                          candidateFailures.push(candidate);
                          errorMsgList.push(`Order ${candidate.entity.Order?.LookupCode} ${(await $flows.Utilities.grammar_format_string_array_flow({ values: reasons })).formattedValue}`);
                      } else {
                          candidateSuccess.push(candidate);
                      }
  
                  } catch (error) {
                      candidateFailures.push(candidate);
                      const errorMessage = $utils.isDefined(error?.error?.error) ? error?.error?.error.message : error;
                      const errorDetail = $utils.isDefined(error?.error?.error) ? error?.error?.error : error;
                      const errorDescription = `Order ${candidate.entity.Order?.LookupCode} - ${errorMessage}`;
                      errorMsgList.push(errorDescription);
                      errorMsgListDetails.push({ message: errorDescription, detail: errorDetail });
                  }
              }
  
              //All succeeded
              if (candidateSuccess.length === candidates.length) {
  
                  const title = 'All order(s) removed';
                  const message = `Order(s) ${candidateSuccess.map(c => c.entity.Order?.LookupCode)?.filter((value, index, array) => array.indexOf(value) === index)?.join(',')} removed`;
                  await $shell.FootprintManager.openInfoDialog(title, message);
                  await $grid.refresh();
  
              } else {
  
                  //All failures
                  if (candidateFailures.length === candidates.length) {
  
                      const title = 'All order(s) failed to be removed';
                      const message = `Order(s) ${candidateFailures.map(c => c.entity.Order?.LookupCode)?.filter((value, index, array) => array.indexOf(value) === index)?.join(',')} could not be removed`;
                      await $shell.FootprintManager.openErrorDialog(title, message, errorMsgList, null, errorMsgListDetails);
  
                  } else {
  
                      const title = 'Some order(s) could not be removed';
                      const success = `Order(s) ${candidateSuccess.map(c => c.entity.Order?.LookupCode)?.filter((value, index, array) => array.indexOf(value) === index)?.join(',')} were removed.`;
                      const errors = `The following order(s) could not be removed: ${candidateFailures.map(c => c.entity.Order?.LookupCode).join(',')}`;
                      const message = `${success} \r\n\r\n${errors}`;
                      await $shell.FootprintManager.openErrorDialog(title, message, errorMsgList, null, errorMsgListDetails);
                      await $grid.refresh();
  
                  }
              }
          }
      }
  }
  
  
  }
  on_add_order(event = null) {
    return this.on_add_orderInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_add_orderInternal(
    $grid: FootprintManager_load_container_orders_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_load_container_orders_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  ///O.Arias -  09/13/2024
  
  let warehouseId;
  
  if ($utils.isDefined($grid.inParams.warehouseId)) {
      warehouseId = $grid.inParams.warehouseId
  } else {
      if ($utils.isDefined($grid.outParams.warehouseId)) {
          warehouseId = $grid.outParams.warehouseId;
      }
  }
  
  const dialogResult = (await $shell.FootprintManager.openload_container_add_ordersDialog ({
  //const dialogResult = (await $shell.FootprintManager.openload_container_add_orders_formDialog({
      warehouseId: warehouseId,
      orderTypeId: $grid.inParams.orderTypeId,
      projectId: $grid.vars.projectId,
      ownerId: $grid.vars.ownerId,
      loadContainerId: $grid.inParams.loadContainerId
  }, "modal"));
  //}));
  
  $grid.refresh();
  
  }
  on_data_loaded(event = null) {
    return this.on_data_loadedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_data_loadedInternal(
    $grid: FootprintManager_load_container_orders_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_load_container_orders_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  //O.Arias - 09/13/2024
  
  const inbound_orders = [];
  const outbound_orders = [];
  
  $grid.topToolbar.add.hidden = true;
  $grid.topToolbar.remove.hidden = true;
  
  
  let createdCount = 0;
  
  for (let row of $grid.rows) {
  
      if (row.entity.Order?.OrderClass.OrderTypeId === 1) {
          inbound_orders.push(row.entity.OrderId)
      }
      if (row.entity.Order?.OrderClass.OrderTypeId === 2) {
          outbound_orders.push(row.entity.OrderId)
      }
  
      if (row.entity.Order?.OrderStatusId === 1) {
          createdCount = createdCount + 1;
      }
  
      // Get the warehouse from the order and return it in the output parameter
      if (!$utils.isDefined($grid.outParams.warehouseId)) {
          if ($utils.isDefined(row.entity.Order?.PreferredWarehouseId)) {
              $grid.outParams.warehouseId = row.entity.Order?.PreferredWarehouseId;
          }
      }
  
      // Get the order type
      if (!$utils.isDefined($grid.outParams.orderTypeId)) {
          if ($utils.isDefined(row.entity.Order?.OrderClass.OrderTypeId)) {
              $grid.outParams.orderTypeId = row.entity.Order?.OrderClass.OrderTypeId;
          }
      }
  
      // Get the owner & project from the orders
      if (!$utils.isDefined($grid.vars.projectId)) {
          if ($utils.isDefined(row.entity.Order?.ProjectId)) {
              $grid.vars.projectId = row.entity.Order?.ProjectId;
              $grid.outParams.projectId = row.entity.Order?.ProjectId;
          }
          if ($utils.isDefined(row.entity.Order?.Project?.OwnerId)) {
              $grid.vars.ownerId = row.entity.Order?.Project?.OwnerId;
              $grid.outParams.ownerId = row.entity.Order?.Project?.OwnerId;
          }
      }
  
      // Get the carrier id
      if (!$utils.isDefined($grid.outParams.carrierId)) {
          if ($utils.isDefined(row.entity.Order?.PreferredCarrierId)) {
              $grid.outParams.carrierId = row.entity.Order?.PreferredCarrierId;
          }
      }
  
  }
  
  $grid.outParams.createdCount = createdCount;
  
  //Only run if inbound load containers are being requested
  if (inbound_orders.length > 0) {
  
      const inbound_shipment_orders = (await $datasources.LoadContainers.ds_get_shipments_from_orders.get({ orderIds: inbound_orders })).result;
      const inbound_shipments = inbound_shipment_orders.map(row => row.ShipmentId);
  
      const receiving_tasks = (await $datasources.LoadContainers.ds_shipment_tasks.get({ shipmentIds: inbound_shipments, statusIds: [2], operationCodeIds: [2] })).result;
      const putaway_tasks = (await $datasources.LoadContainers.ds_shipment_tasks.get({ shipmentIds: inbound_shipments, statusIds: [2], operationCodeIds: [3] })).result;
      const expected_inbound = (await $datasources.LoadContainers.ds_shipment_processed.get({ shipmentIds: inbound_shipments })).result;
  
      const receiving_array = receiving_tasks.map(row => row.ShipmentId);
      const putaway_array = putaway_tasks.map(row => row.ShipmentId);
      const expected_array = expected_inbound.map(row => row.Shipment.Id);
  
      for (let row of $grid.rows) {
  
          let received_total = 0;
          let putaway_total = 0;
          let expected_total = 0;
  
          if (row.entity.Order?.OrderClass.OrderTypeId === 1) {
  
              for (let shipment_order of inbound_shipment_orders) {
  
                  if (shipment_order.ShipmentId === row.entity.ShipmentId) {
  
                      if (shipment_order.OrderId === row.entity.OrderId) {
  
                          let shipmentId = shipment_order.ShipmentId;
                          let shipmentIndex = -1;
  
                          //Get the total received inventory
                          shipmentIndex = receiving_array.indexOf(shipmentId)
                          if (shipmentIndex >= 0) {
                              received_total = received_total + receiving_tasks[shipmentIndex].ActualAmount;
                          }
  
                          //Get the total putaway inventory
                          shipmentIndex = putaway_array.indexOf(shipmentId)
                          if (shipmentIndex >= 0) {
                              putaway_total = putaway_total + putaway_tasks[shipmentIndex].ActualAmount;
                          }
  
                          //Get the total expected inventory
                          shipmentIndex = expected_array.indexOf(shipmentId)
                          if (shipmentIndex >= 0) {
                              expected_total = expected_total + expected_inbound[shipmentIndex].Amount;
                          }
                      }
                  }
  
                  if (received_total > 0 && expected_total > 0) {
                      row.cells.Received.displayControl.text = calculatePercentage(received_total, expected_total);
                  } else {
                      row.cells.Received.displayControl.text = "0.0%"
                  }
  
                  if (putaway_total > 0 && expected_total > 0) {
                      row.cells.Putaway.displayControl.text = calculatePercentage(putaway_total, expected_total);
                  } else {
                      row.cells.Putaway.displayControl.text = "0.0%"
                  }
              }
          }
      }
  }
  
  //Only run if outbound load containers are being requested
  if (outbound_orders.length > 0) {
  
      const outbound_shipment_orders = (await $datasources.LoadContainers.ds_get_shipments_from_orders.get({ orderIds: outbound_orders })).result;
      const outbound_shipments = outbound_shipment_orders.map(row => row.ShipmentId);
  
      const contents = (await $datasources.LoadContainers.ds_shipment_contents.get({ shipmentIds: outbound_shipments, loadTasks: false })).result;
      const contents_loaded = (await $datasources.LoadContainers.ds_shipment_contents.get({ shipmentIds: outbound_shipments, loadTasks: true })).result;
      const contents_archived = (await $datasources.LoadContainers.ds_shipment_archived_contents.get({ shipmentIds: outbound_shipments })).result;
      const expected = (await $datasources.LoadContainers.ds_shipment_expected.get({ shipmentIds: outbound_shipments })).result;
      const processed = (await $datasources.LoadContainers.ds_shipment_processed.get({ shipmentIds: outbound_shipments })).result;
      const available = (await $datasources.LoadContainers.ds_shipment_expected.get({ shipmentIds: outbound_shipments, statusId: 1, available: true })).result;
  
      const contents_array = contents.map(row => row.LicensePlate.ShipmentId);
      const contents_loaded_array = contents_loaded.map(row => row.LicensePlate.ShipmentId);
      const contents_archived_array = contents_archived.map(row => row.LicensePlate.ShipmentId);
      const expected_array = expected.map(row => row.Shipment.Id);
      const processed_array = processed.map(row => row.Shipment.Id);
      const available_array = available.map(row => row.Shipment.Id);
  
      for (let row of $grid.rows) {
  
          let picked_content = 0;
          let picked_content_loaded = 0;
          let picked_archived_content = 0;
          let expected_total = 0;
          let processed_total = 0;
          let available_total = 0;
          let loaded_total = 0;
          let picked_total = 0;
          let pick_pending = 0;
          let total_amount = 0;
          let total_available = 0;
  
          if (row.entity.Order?.OrderClass.OrderTypeId === 2) {
  
              for (let shipment_order of outbound_shipment_orders) {
  
                  if (shipment_order.ShipmentId === row.entity.ShipmentId) {
  
                      if (shipment_order.OrderId === row.entity.OrderId) {
  
                          let shipmentId = shipment_order.ShipmentId;
                          let shipmentIndex = -1;
  
                          //Get the total picked amount for the load container
                          shipmentIndex = contents_array.indexOf(shipmentId)
                          if (shipmentIndex >= 0) {
                              picked_content = picked_content + contents[shipmentIndex].Amount;
                          }
  
                          //Get the total picked & loaded amount for the load container
                          shipmentIndex = contents_loaded_array.indexOf(shipmentId)
                          if (shipmentIndex >= 0) {
                              picked_content_loaded = picked_content_loaded + contents_loaded[shipmentIndex].Amount;
                          }
  
                          //Get the total archived amount for the load container, if it's archived we assume it's picked and loaded
                          shipmentIndex = contents_archived_array.indexOf(shipmentId)
                          if (shipmentIndex >= 0) {
                              picked_archived_content = picked_archived_content + contents_archived[shipmentIndex].Amount;
                          }
  
                          //Get the total expected amount
                          shipmentIndex = expected_array.indexOf(shipmentId)
                          if (shipmentIndex >= 0) {
                              expected_total = expected_total + expected[shipmentIndex].Amount;
                          }
  
                          //Get the total processed amount
                          shipmentIndex = processed_array.indexOf(shipmentId)
                          if (shipmentIndex >= 0) {
                              processed_total = processed_total + processed[shipmentIndex].Amount;
                          }
  
                          //Get the total available amount
                          shipmentIndex = available_array.indexOf(shipmentId)
                          if (shipmentIndex >= 0) {
                              available_total = available_total + available[shipmentIndex].Amount;
                          }
  
                          picked_total = picked_total + picked_content + picked_archived_content
                          loaded_total = loaded_total + picked_content_loaded + picked_archived_content
                          pick_pending = pick_pending + expected_total - picked_total
  
                          if (pick_pending < 0) {
                              pick_pending = 0
                          }
  
                          total_amount = total_amount + expected_total;
                          total_available = total_available + processed_total + available_total;
                      }
  
                      if (loaded_total > 0 && total_amount > 0) {
                          row.cells.Loaded.displayControl.text = calculatePercentage(loaded_total, total_amount);
                      } else {
                          row.cells.Loaded.displayControl.text = "0.0%"
                      }
  
                      if (picked_total > 0 && total_amount > 0) {
                          row.cells.Picked.displayControl.text = calculatePercentage(picked_total, total_amount);
                      } else {
                          row.cells.Picked.displayControl.text = "0.0%"
                      }
  
                      if (total_available > 0 && total_amount > 0) {
                          row.cells.Available.displayControl.text = calculatePercentage(total_available, total_amount);
                      } else {
                          row.cells.Available.displayControl.text = "0.0%"
                      }
                  }
              }
          }
      }
  }
  
  //Emit the out params change
  if ($utils.isDefined($grid.outParams.warehouseId) || $utils.isDefined($grid.outParams.carrierId) || $utils.isDefined($grid.outParams.orderTypeId) || $utils.isDefined($grid.outParams.ownerId) || $utils.isDefined($grid.outParams.projectId) || $utils.isDefined($grid.outParams.createdCount)) {
  
      $grid.events.outParamsChange.emit();
  }
  
  if ($utils.isDefined($grid.inParams.status_id)) {
      // Unhide buttons if not in a completed, call-out, or closed status
      if (![4, 5, 6].includes($grid.inParams.status_id)) {
  
          $grid.topToolbar.add.hidden = false;
          $grid.topToolbar.remove.hidden = false;
      }
  }
  
  function calculatePercentage(a, b) {
      if (b === 0) {
          return "Cannot divide by zero.";
      }
      const percentage = (a / b) * 100;
      return percentage.toFixed(2) + "%";
  }
  }
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $grid: FootprintManager_load_container_orders_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_load_container_orders_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  //O.Arias - 08/02/2023
  
  //Hide the columns based on order type
  
  if ($grid.inParams.orderTypeId === 1) {
  
      $grid.headers.Available.name = null;
      $grid.headers.Loaded.name = null;
      $grid.headers.Picked.name = null;
  
  };
  
  if ($grid.inParams.orderTypeId === 2) {
  
      $grid.headers.Received.name = null;
      $grid.headers.Putaway.name = null;
      
  };
  
  
  }
  //#endregion private flows


 
  close() {
    this.$finish.emit();
  }
}
